import { CampaignStatus } from 'types';

const DEFAULT_CAMPAIGN_ACTIONS = {
  isOverviewAvailable: false,
  isDuplicateAvailable: false,
  isStopAvailable: false,
  isPdfReportAvailable: false,
  isDeleteAvailable: false,
  isEditAvailable: false,
};

export const useCampaignActionsByStatus = (status?: CampaignStatus) => {
  if (!status) {
    return DEFAULT_CAMPAIGN_ACTIONS;
  }

  return {
    isOverviewAvailable: status !== CampaignStatus.draft,
    isDuplicateAvailable: true,
    isStopAvailable: [CampaignStatus.ready, CampaignStatus.active].includes(status),
    isPdfReportAvailable: [CampaignStatus.active, CampaignStatus.over, CampaignStatus.stopped].includes(status),
    isDeleteAvailable: status === CampaignStatus.draft,
    isEditAvailable: status === CampaignStatus.draft,
  };
};
